<template>
  <div class="moduleStyle minHeight">
    <div class="tabs">
      <ul>
        <li
          :class="activeId == item.val ? 'tabs_active' : ''"
          @click="changeTabs(item.val)"
          v-for="item in visibleTabslist"
          :key="item.val"
        >
          {{ item.label }}
        </li>
      </ul>
      <div class="tabsbutton">
        <template v-if="hasPermission('销售-销售单-新增')">
          <el-button
            size="small"
            icon="el-icon-plus"
            type="primary"
            @click="newlyAdded"
            >新增销售单</el-button
          >
        </template>

        <template>
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            style=""
            @click="exportExcel(basicListconfig.searchParameters)"
          >
            导出
          </el-button>
        </template>
      </div>
    </div>
    <div style="height: 20px"></div>
    <div class="table" v-if="activeId == 1">
      <basicList
        :config="basicListconfig"
        @sortChange="sortChange"
        @search="searchEvent"
      >
        <template v-slot:additionalFeatures>
          <div class="procurementDataSummary procurementDataSummary2">
            <ul>
              <li>
                <div>
                  <div class="summaryTitle">今日销售</div>
                  <div class="today summaryLine">
                    <p>¥{{ summarizeData.daily_total_money | money }}</p>
                  </div>
                </div>
                <div class="subtotals">
                  <p>销量：{{ summarizeData.daily_num }} 瓶</p>
                  <p>未结：¥ {{ summarizeData.daily_last_money | money }}</p>
                  <p>
                    毛利：¥ {{ summarizeData.daily_real_profit_money | money }}
                  </p>
                </div>
              </li>
              <li>
                <div>
                  <div class="summaryTitle">昨日销售</div>
                  <div class="yesterday summaryLine">
                    <p>¥ {{ summarizeData.yesterday_total_money | money }}</p>
                  </div>
                </div>
                <div class="subtotals">
                  <p>销量：{{ summarizeData.yesterday_num }} 瓶</p>
                  <p>
                    未结：¥ {{ summarizeData.yesterday_last_money | money }}
                  </p>
                  <p>
                    毛利：¥
                    {{ summarizeData.yesterday_real_profit_money | money }}
                  </p>
                </div>
              </li>
              <!-- <li>
              <div>
                <div class="summaryTitle">十日销售</div>
                <div class="summaryLine">
                  <p>¥ {{ summarizeData.tendays_total_money | money }}</p>
                </div>
              </div>
              <div class="subtotals">
                <p>销量：{{ summarizeData.tendays_num }} 瓶</p>
                <p>未结：¥ {{ summarizeData.tendays_last_money | money }}</p>
              </div>
            </li> -->
              <li>
                <div>
                  <div class="summaryTitle">查询汇总</div>
                  <div class="summaryLine">
                    <p>¥ {{ summarizeData.total_money | money }}</p>
                  </div>
                </div>
                <div class="subtotals">
                  <p>销量：{{ summarizeData.num }} 瓶</p>
                  <p>未结：¥ {{ summarizeData.last_money | money }}</p>
                  <p>毛利：¥ {{ summarizeData.real_profit_money | money }}</p>
                </div>
              </li>

              <!-- <li>
              <div class="summaryTitle">
                未结清
                <el-popover
                  placement="top-start"
                  class="tip_mr"
                  trigger="click"
                >
                  内容待定中...
                  <img src="../../assets/images/tip.png" slot="reference" />
                </el-popover>
              </div>
              <div class="uncleared summaryLine">
                <p>¥ 1,210,858</p>
                1669瓶
              </div>
            </li> -->
            </ul>
          </div>
          <div style="height: 20px"></div>
        </template>
        <template v-slot:real_profit_money="row">
          <template v-if="row.row.real_profit_money < 0">
            <el-link type="danger">{{
              row.row.real_profit_money | money
            }}</el-link>
          </template>
          <template v-else>
            {{ row.row.real_profit_money | money }}
          </template>
        </template>
        <template v-slot:last_money="row">
          <template v-if="row.row.last_money > 0">
            <el-link type="danger">{{ row.row.last_money | money }}</el-link>
          </template>
          <template v-else>
            {{ row.row.last_money | money }}
          </template>
        </template>
        <template v-slot:operation="row">
          <div style="display: flex; align-items: center">
            <template
              v-if="
                hasPermission('销售-销售单-编辑') &&
                (row.row.status == 1 || row.row.status == 2)
              "
            >
              <div class="button button_modify" @click="editButton(row.row)">
                <i class="iconfont icon-bianji"></i> 编辑
              </div>
            </template>
            <template v-else>
              <div class="button button_modify" @click="preview(row.row)">
                <i class="iconfont icon-yulanmoban"></i> 查看
              </div>
            </template>

            <el-popover
              v-if="!isTakeoutRole"
              :visible-arrow="false"
              placement="bottom"
              width="80"
              trigger="click"
            >
              <ul class="moreOperations">
                <li
                  v-if="row.row.last_money > 0 && row.row.status == 0"
                  @click="shoudGetButton(row.row)"
                >
                  <i class="iconfont icon-jiezhang"></i> 结账
                </li>
                <template
                  v-if="
                    !(
                      hasPermission('销售-销售单-编辑') &&
                      (row.row.status == 1 || row.row.status == 2)
                    )
                  "
                >
                  <li @click="show(row.row)">
                    <i class="iconfont el-icon-warning-outline"></i> 溯源
                  </li>
                  <li
                    v-if="
                      row.row.create_date.substr(0, 10) ===
                      new Date(Date.now() + 8 * 60 * 60 * 1000)
                        .toISOString()
                        .substr(0, 10)
                    "
                    @click="freight(row.row, 'in')"
                  >
                    <i class="iconfont el-icon-truck"></i> 运入
                  </li>
                  <li @click="freight(row.row, 'out')">
                    <i class="iconfont el-icon-truck"></i> 运出
                  </li>
                </template>
                <li
                  v-if="
                    hasPermission('销售-销售单-删除') &&
                    (row.row.status == 1 || row.row.status == 2)
                  "
                  @click="deleteRows(row.row)"
                >
                  <i class="iconfont icon-shanchu"></i> 删除
                </li>

                <li
                  v-if="
                    row.row.payed_money == 0 &&
                    row.row.status == 0 &&
                    row.row.trans_money_self == '0.00' &&
                    row.row.create_date.substr(0, 10) ===
                      new Date(Date.now() + 8 * 60 * 60 * 1000)
                        .toISOString()
                        .substr(0, 10)
                  "
                  @click="checkout(row.row)"
                >
                  <i class="iconfont icon-chehui03"></i> 撤回
                </li>
                <li @click="printSettings(row.row)">
                  <i class="iconfont icon-dayin"></i> 打印
                </li>
              </ul>
              <div slot="reference" class="button button_more">
                <img src="../../assets/images/icon_more.png" />
              </div>
            </el-popover>
          </div>
        </template>
      </basicList>
    </div>
    <div class="table" v-if="activeId == 2">
      <basicList
        :config="basicListconfigyu"
        @sortChange="sortChangeyu"
        @search="searchEventyu"
      >
        <template v-slot:last_money="row">
          <template v-if="row.row.last_money > 0">
            <el-link type="danger">{{ row.row.last_money | money }}</el-link>
          </template>
          <template v-else>
            {{ row.row.last_money | money }}
          </template>
        </template>
        <template v-slot:operation="row">
          <div style="display: flex; align-items: center">
            <template
              v-if="
                hasPermission('销售-销售单-编辑') &&
                (row.row.status == 1 || row.row.status == 2)
              "
            >
              <div class="button button_modify" @click="editButton(row.row)">
                <i class="iconfont icon-bianji"></i> 编辑
              </div>
            </template>
            <template v-else>
              <div class="button button_modify" @click="preview(row.row)">
                <i class="iconfont icon-yulanmoban"></i> 查看
              </div>
            </template>

            <el-popover
              v-if="!isTakeoutRole"
              :visible-arrow="false"
              placement="bottom"
              width="80"
              trigger="click"
            >
              <ul class="moreOperations">
                <li @click="editButton(row.row)">
                  <i class="iconfont icon-bianji"></i> 编辑
                </li>
                <li @click="deleteRowsyu(row.row)">
                  <i class="iconfont icon-shanchu"></i> 删除
                </li>
                <li @click="printSettings(row.row)">
                  <i class="iconfont icon-dayin"></i> 打印
                </li>
              </ul>
              <div slot="reference" class="button button_more">
                <img src="../../assets/images/icon_more.png" />
              </div>
            </el-popover>
          </div>
        </template>
      </basicList>
    </div>
    <sourceTracing
      v-if="sourceTracingParams.visible"
      :dialogParams="sourceTracingParams"
      @close="handleSourceTracingClose"
    ></sourceTracing>

    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <!-- <sourceList
      v-if="sourceTracingParams.visible"
      :dialogParams="sourceTracingParams"
      @close="handleSourceTracingClose"
    ></sourceList> -->
    <Freigth :config="freightConfig" @close="closefreightConfig"></Freigth>
    <previewComponents
      @close="closeView"
      :acceptedParameters="previewParams"
      @refresh="refresh"
    ></previewComponents>
    <!-- 打印组件 -->
    <printingComponents
      @close="closePrinting"
      :acceptedParameters="printingParameter"
      @refresh="refreshPrinting"
    ></printingComponents>

    <!-- <shoudGetformWindow
      :dialogParams="shoudGetParams"
      @close="closeThePopUpWindow2"
    ></shoudGetformWindow> -->

    <checkoutComponent
      :dialogParams="shoudGetParams"
      @close="closeThePopUpWindow2"
    ></checkoutComponent>

    <el-dialog
      :title="printTitle"
      :visible.sync="printSettingsVisible"
      custom-class="addProductPopUpWindow"
      width="600px"
      append-to-body
    >
      <el-checkbox-group v-model="checkList">
        <div v-for="(item, index) in printingParameters" :key="index">
          <el-row :gutter="20">
            <div v-for="list in item" :key="list">
              <el-col :span="8">
                <el-checkbox :label="list"></el-checkbox>
                <div style="height: 15px"></div>
              </el-col>
            </div>
          </el-row>
        </div>
      </el-checkbox-group>
      <div slot="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button type="primary" @click="confirmPrinting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { getSession } from "@/utils/cookie";
import { mapGetters } from "vuex";
import {
  orderSellGetList,
  orderSellDel,
  orderSellUnDo,
  getOrderAllInfo,
  orderSellGetOne,
} from "@/api/sale";
import {
  getshoplist,
  customerGetList,
  userPermissionShopGetList,
  userGetlist,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "salesManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
    // sourceList: () => import("@/views/productTraceability/sourceList.vue"),
    sourceTracing: () =>
      import("@/views/productTraceability/sourceTracing.vue"),
    Freigth: () => import("./freigth.vue"),
    previewComponents: () => import("@/components/previewComponents"),
    printingComponents: () => import("@/components/printingComponents"),
    checkoutComponent: () => import("@/components/checkoutComponent"),
  },
  data() {
    return {
      previewParams: {
        key: new Date().getTime(),
        visible: false,
        type: "saleOrder",
        viewObj: [],
        code: "",
        isTakeoutRole: false,
      },
      printingParameter: {
        key: new Date().getTime(),
        visible: false,
        type: "saleOrder",
        viewObj: [],
        code: "",
      },
      // 打印参数
      printSettingsVisible: false,
      downloadUrl: "",
      printingParameters: [
        [
          "客户",
          "公司名称",
          "联系电话",
          "联系地址",
          "销售门店",
          "业务员",
          "制单人",
          "销售日期",
          "备注",
        ],
        [
          "运费收入",
          "商品数量",
          "订单金额",
          "运费支出",
          "余额抵扣",
          "应收总金额",
          "收款信息",
          "物流码",
          "条码",
        ],
      ],
      checkList: [
        "客户",
        "销售门店",
        "物流码",
        "业务员",
        "备注",
        "商品数量",
        "订单金额",
        "联系电话",
        "联系地址",
        "销售日期",
      ],
      compId: null,
      userId: null,
      roleId: null,
      shopIds: [], // 权限管理中允许用户使用的店铺，高级角色看所有店铺
      activeId: 1,
      tabslist: [
        {
          label: "销售单",
          val: 1,
        },
        {
          label: "预售单",
          val: 2,
        },
      ],
      // // 溯源弹窗
      // sourceTracingParams: {
      //   key: new Date().getTime(),
      //   visible: false,
      //   id: "",
      // },
      // 溯源弹窗
      sourceTracingParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        flow_type: -1,
      },
      enlargedImage: null,

      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
        status: "",
      },

      shoudGetParams: {
        key: new Date().getTime(),
        visible: false,
        unpaidAmount: "",
        id: "",
      },

      // 列表组件参数
      basicListconfig: {
        loading: false,
        operationWidth: 140,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "客户",
            type: "select",
            key: "customer_id",
            options: [],
          },
          {
            label: "类型",
            type: "select",
            key: "supplier_types",
            multiple: true,
            options: [
              {
                label: "同行",
                value: 1,
              },
              {
                label: "分销",
                value: 2,
              },
              {
                label: "团购",
                value: 3,
              },
              {
                label: "外卖",
                value: 4,
              },
              {
                label: "零售",
                value: 5,
              },
            ],
          },
          {
            label: "单号/备注",
            type: "input",
            key: "form_sn",
          },
          {
            label: "",
            type: "daterange",
            key: "create_time",
          },
          {
            label: "状态",
            type: "select",
            options: [
              {
                label: "正常",
                value: 0,
              },
              {
                label: "取消",
                value: 1,
              },
            ],
            key: "status",
          },
          {
            label: "业务员",
            type: "select",
            options: [],
            key: "user_id",
          },
        ],

        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "开单时间",
            prop: "create_time",
            sortable: true,
            width: 200,
          },
          // {
          //   label: "日期",
          //   prop: "create_date",
          //   sortable: true,
          //   width: 120,
          // },

          {
            label: "客户",
            prop: "customer_name",
            width: 180,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 150,
          },
          {
            label: "数量",
            prop: "num",
            sortable: true,
            width: 80,
          },
          {
            label: "订单金额",
            prop: "total_money",
            isMoney: true,
            sortable: true,
            width: 120,
          },
          {
            label: "未付",
            prop: "last_money",
            sortable: true,
            slot: true,
            width: 120,
          },
          {
            label: "净毛利",
            prop: "real_profit_money",
            slot: true,
            sortable: true,
            width: 120,
          },
          {
            label: "运费支出",
            prop: "trans_money_self",
            isMoney: true,
            sortable: true,
            width: 120,
          },
          {
            label: "业务员",
            prop: "customer_user_name",
            width: 120,
          },
          {
            label: "出库人",
            prop: "user_name",
            width: 120,
          },
          {
            label: "状态",
            prop: "status",
            filter: "documentStatus",
            width: 80,
          },
          {
            label: "备注",
            prop: "remark",
            width: 300,
          },
          {
            label: "销售单号",
            prop: "form_sn",
            width: 220,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      basicListconfigyu: {
        loading: false,
        operationWidth: 140,
        search: [
          {
            label: "门店",
            type: "select",
            options: [],
            key: "shop_id",
          },
          {
            label: "客户",
            type: "select",
            key: "customer_id",
            options: [],
          },
          {
            label: "类型",
            type: "select",
            key: "supplier_types",
            multiple: true,
            options: [
              {
                label: "同行",
                value: 1,
              },
              {
                label: "分销",
                value: 2,
              },
              {
                label: "团购",
                value: 3,
              },
              {
                label: "外卖",
                value: 4,
              },
              {
                label: "零售",
                value: 5,
              },
            ],
          },
          {
            label: "单号",
            type: "input",
            key: "form_sn",
          },
          {
            label: "",
            type: "daterange",
            key: "create_time",
          },
        ],

        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            sortable: true,
            width: 100,
          },
          {
            label: "开单时间",
            prop: "create_time",
            sortable: true,
            width: 200,
          },
          // {
          //   label: "日期",
          //   prop: "create_date",
          //   sortable: true,
          //   width: 120,
          // },

          {
            label: "客户",
            prop: "customer_name",
            width: 180,
          },
          {
            label: "门店",
            prop: "shop_name",
            width: 150,
          },
          {
            label: "数量",
            prop: "num",
            sortable: true,
            width: 80,
          },
          {
            label: "订单金额",
            prop: "total_money",
            isMoney: true,
            sortable: true,
            width: 120,
          },
          {
            label: "未付",
            prop: "last_money",
            sortable: true,
            slot: true,
            width: 120,
          },
          {
            label: "净毛利",
            prop: "real_profit_money",
            isMoney: true,
            sortable: true,
            width: 120,
          },
          {
            label: "运费支出",
            prop: "trans_money_self",
            isMoney: true,
            sortable: true,
            width: 120,
          },
          {
            label: "出库人",
            prop: "user_name",
            width: 80,
          },
          {
            label: "状态",
            prop: "status",
            filter: "documentStatus",
            width: 80,
          },
          {
            label: "备注",
            prop: "remark",
            width: 300,
          },
          {
            label: "销售单号",
            prop: "form_sn",
            width: 220,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      summarizeData: {},
      freightConfig: {
        visible: false,
        key: new Date().getTime(),

        data: {
          shop_id: "",
          money: "",
          id: "",
          part_id: "",
          from_sn: "",
          comp_id: "",
        },
      },
      printTitle: "",
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;

    this.applyTakeoutConstraints();

    // 初始化列表内容
    this.obtainDataSource().then(() => {
      if (this.roleId == 4 || this.isTakeoutRole) {
        this.basicListconfig.searchParameters.shop_id =
          this.$store.getters.userInfo.shopId;
      }
      this.getlist(); // 先拿基础数据，在拉记录
    });

    this.headers = {
      "x-token": getSession(),
    };

    switch (process.env.NODE_ENV) {
      // 线上同源
      case "prod":
        this.host = "http://47.100.124.64";
        break;
      // 开发同源
      case "dev":
        this.host = "https://erp.zuizhenshi.cn";
        break;
      // 开发跨域
      case "local":
        this.host = "https://erp.zuizhenshi.cn";
        break;
    }
    // this.downloadUrl = this.host + "/admin/order_sell/exportExcel";
    this.downloadUrl = "https://erp.zuizhenshi.cn/admin/order_sell/exportExcel";
  },
  computed: {
    ...mapGetters(["hasPermission", "getPermissionId", "isTakeoutRole"]),
    visibleTabslist() {
      if (this.isTakeoutRole) {
        return this.tabslist.filter((item) => item.val === 1);
      }
      return this.tabslist;
    },
  },
  methods: {
    applyTakeoutConstraints() {
      if (!this.isTakeoutRole) {
        return;
      }
      this.activeId = 1;
      const removeSupplierTypeFilter = (searchFields = []) => {
        const index = searchFields.findIndex(
          (item) => item.key === "supplier_types"
        );
        if (index > -1) {
          searchFields.splice(index, 1);
        }
      };
      removeSupplierTypeFilter(this.basicListconfig.search);
      removeSupplierTypeFilter(this.basicListconfigyu.search);
      this.enforceTakeoutSupplierType(this.basicListconfig.searchParameters);
      this.enforceTakeoutSupplierType(this.basicListconfigyu.searchParameters);
    },
    enforceTakeoutSupplierType(target) {
      if (this.isTakeoutRole && target) {
        target["supplier_type"] = 4;
      }
    },
    changeTabs(id) {
      this.activeId = id;
      if (id == 1) {
        this.getlist();
        // 在这一页，把其他两页的残留数据清理掉
        this.dailyDiskLibraryListconfig.data = [];
        this.overdueListconfig.data = [];
      } else if (id == 2) {
        this.getlistyu({ type_id: 1 });
      }
    },
    cancel() {
      this.printSettingsVisible = false;
    },
    isItDisplayed(name) {
      return this.checkList.includes(name);
    },
    confirmPrinting() {
      const row = this.temporaryRowData;
      this.printingParameter.code = row.form_sn;
      this.printingParameter.documentName = "销售码";
      // this.printingParameter.traceabilityId = row.id;
      this.printingParameter.isShowCode = !this.isItDisplayed("物流码");
      orderSellGetOne({ form_sn: row.form_sn }).then((res) => {
        if (res.code == 1) {
          let payData = res.$pay_list.map((item) => {
            item.pay_price = this.$money(item.pay_price);
            item.all_price = this.$money(item.all_price);
            item.last_price = this.$money(item.last_price);
            return item;
          });
          if (res.item_way.length > 0) {
            this.printingParameter.traceabilityId = res.item_way[0].id;
          } else {
            this.printingParameter.traceabilityId = "*";
          }
          let data = res.$order_list.map((item) => {
            if (this.isItDisplayed("条码")) {
              item.name =
                item.item_info.name + "(" + item.item_info.item_number + ")";
            } else {
              item.name =
                item.item_info.name +
                "(1*" +
                item.item_info.in_package_num +
                ")";
            }

            item.type_spec = item.item_info.type_spec;
            item.freeze_num = item.item_info.freeze_num;
            item.price_distribution = this.$money(item.price_distribution);
            item.item_stock_single = item.item_info.item_stock_single;
            item.item_stock_package = item.item_info.item_stock_package;
            item.total_money = this.$money(item.total_money);
            item.algorithm =
              item.price_distribution +
              "*" +
              "(" +
              item.single_num +
              "+" +
              item.package_num +
              "*" +
              item.item_info.in_package_num +
              ")" +
              "=" +
              item.total_money;
            item.total =
              Number(item.single_num) +
              Number(item.package_num) * Number(item.item_info.in_package_num);
            return item;
          });
          this.printingParameter.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "客户",
                  value: res.order_info.customer_name_short,
                  show: !this.isItDisplayed("客户"),
                },
                {
                  label: "公司名称",
                  value: res.order_info.comp_remark,
                  show: !this.isItDisplayed("公司名称"),
                },
                {
                  label: "联系电话",
                  value: res.order_info.customer_tel,
                  show: !this.isItDisplayed("联系电话"),
                },
                {
                  label: "联系地址",
                  value: res.order_info.customer_address,
                  show: !this.isItDisplayed("联系地址"),
                },
                {
                  label: "销售门店",
                  value: res.order_info.shop_name,
                  show: !this.isItDisplayed("销售门店"),
                },
                {
                  label: "业务员",
                  value: res.order_info.customer_user_name,
                  show: !this.isItDisplayed("业务员"),
                },
                {
                  label: "制单人",
                  value: res.order_info.user_name,
                  show: !this.isItDisplayed("制单人"),
                },
                {
                  label: "销售日期",
                  value: res.order_info.create_time,
                  show: !this.isItDisplayed("销售日期"),
                },
                {
                  label: "备注",
                  value: res.order_info.remark,
                  show: !this.isItDisplayed("备注"),
                },
              ],
            },
            {
              title: "销售明细",
              show: false,
              type: "array",
              value: data,
              column: [
                {
                  label: "商品名称",
                  prop: "name",
                },
                {
                  label: "单位",
                  prop: "type_spec",
                },
                {
                  label: "单价",
                  prop: "price_distribution",
                  show: !this.isItDisplayed("订单金额"),
                },
                {
                  label: "数量",
                  prop: "total",
                },
                {
                  label: "小计",
                  prop: "total_money",
                  show: !this.isItDisplayed("订单金额"),
                },
              ],
            },
            {
              title: "",
              show: !(
                this.isItDisplayed("应收总金额") ||
                this.isItDisplayed("运费收入") ||
                this.isItDisplayed("订单金额") ||
                this.isItDisplayed("运费支出") ||
                this.isItDisplayed("余额抵扣")
              ),
              type: "object",
              value: [
                {
                  label: "商品数量",
                  value: res.order_info.num,
                  show: !this.isItDisplayed("商品数量"),
                },
                {
                  label: "商品金额",
                  value: this.$money(res.order_info.item_money),
                  show: !this.isItDisplayed("订单金额"),
                },
                {
                  label: "运费收入",
                  value: this.$money(res.order_info.trans_money),
                  show: !this.isItDisplayed("运费收入"),
                },
                {
                  label: "订单金额",
                  value: this.$money(res.order_info.total_money),
                  show: !this.isItDisplayed("订单金额"),
                },
                // {
                //   label: "总数量",
                //   value: res.order_info.num,
                //   show: !this.isItDisplayed("总数量"),
                // },
                {
                  label: "运费支出",
                  show: !this.isItDisplayed("运费支出"),
                  value: this.$money(res.order_info.trans_money_self),
                },
                {
                  label: "余额抵扣",
                  value: this.$money(res.order_info.pre_money),
                  show: !this.isItDisplayed("余额抵扣"),
                },
                {
                  label: "应收总金额",
                  value: this.$money(
                    Number(res.order_info.total_money) -
                      Number(res.order_info.pre_money)
                  ),
                  show: !this.isItDisplayed("应收总金额"),
                },
              ],
            },
            {
              title: "收款信息",
              type: "array",
              show: !this.isItDisplayed("收款信息"),
              value: payData,
              column: [
                {
                  label: "收款账户",
                  prop: "account_name",
                },
                {
                  label: "结款余额",
                  prop: "pay_price",
                },
                {
                  label: "时间",
                  width: "40%",
                  prop: "create_time",
                },
              ],
            },
            {
              title: "",
              type: "object",
              show: !this.isItDisplayed("收款信息"),
              value: [
                {
                  label: "已收金额",
                  value: this.$money(res.order_info.payed_money),
                  show: !this.isItDisplayed("收款信息"),
                },
                {
                  label: "未收金额",
                  value: this.$money(res.order_info.last_money),
                  show: !this.isItDisplayed("收款信息"),
                },
              ],
            },
            // {
            //   title: "物流码",
            //   type: "object",
            //   show: !this.isItDisplayed("物流码"),
            //   value: [
            //     {
            //       label: "",
            //       value: item_way,
            //       show: !this.isItDisplayed("物流码"),
            //     },
            //   ],
            // },
          ];

          this.printingParameter.key = new Date().getTime();
          this.printingParameter.visible = true;
          this.printingParameter.type = "sale";
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    // 打印参数设置
    printSettings(row) {
      this.temporaryRowData = row;
      this.printTitle = "单据号:" + row.form_sn + "打印设置";
      this.printSettingsVisible = true;
    },
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    sortChangeyu(data) {
      this.basicListconfigyu.searchParameters.page = 1;
      this.basicListconfigyu.searchParameters.order_column = data.prop;
      this.basicListconfigyu.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlistyu();
    },
    // 关闭查看
    closeView() {
      this.previewParams.key = new Date().getTime();
      this.previewParams.visible = false;
    },
    closePrinting() {
      this.printingParameter.key = new Date().getTime();
      this.printingParameter.visible = false;
    },
    refresh() {
      this.preview(this.temporaryRowData, "previewParams");
    },
    refreshPrinting() {
      this.preview(this.temporaryRowData, "printingParameter");
    },
    preview(row, name) {
      this.temporaryRowData = row;
      this.previewParams.code = row.form_sn;
      this.previewParams.isTakeoutRole = this.isTakeoutRole;
      orderSellGetOne({ form_sn: row.form_sn }).then((res) => {
        if (res.code == 1) {
          let payData = res.$pay_list.map((item) => {
            item.pay_price = this.$money(item.pay_price);
            item.all_price = this.$money(item.all_price);
            item.last_price = this.$money(item.last_price);
            return item;
          });
          let item_way = res.item_way.map((item) => {
            if (item.pics) item.pics = item.pics.split(",");
            return item;
          });
          let data = res.$order_list.map((item) => {
            item.name =
              item.item_info.name +
              "(1*" +
              item.item_info.in_package_num +
              ")(" +
              item.item_info.item_number +
              ")";
            item.freeze_num = item.item_info.freeze_num;
            item.price_distribution = this.$money(item.price_distribution);
            item.item_stock_single = item.item_info.item_stock_single;
            item.item_stock_package = item.item_info.item_stock_package;
            item.total_money = this.$money(item.total_money);
            item.def_money = this.$money(item.def_money);
            item.algorithm =
              item.price_distribution +
              "*" +
              "(" +
              item.single_num +
              "+" +
              item.package_num +
              "*" +
              item.item_info.in_package_num +
              ")" +
              "=" +
              item.total_money;
            item.total = item.num;
            //   Number(item.single_num) +
            //   Number(item.package_num) * Number(item.item_info.in_package_num);
            return item;
          });
          this.previewParams.viewObj = [
            {
              title: "",
              type: "object",
              value: [
                {
                  label: "客户",
                  value: res.order_info.customer_name,
                },
                {
                  label: "销售门店",
                  value: res.order_info.shop_name,
                },
                {
                  label: "业务员",
                  value: res.order_info.customer_user_name,
                },
                {
                  label: "制单人",
                  value: res.order_info.user_name,
                },
              ],
            },
            {
              title: "销售明细",
              type: "array",
              value: data,
              column: [
                {
                  label: "商品名称",
                  prop: "name",
                  width: 500,
                },
                {
                  label: "销售单价",
                  prop: "price_distribution",
                },

                {
                  label: "销售总量",
                  prop: "total",
                  align: "center",
                  // children: [
                  //   {
                  //     label: "散",
                  //     prop: "single_num",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "箱",
                  //     prop: "package_num",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "总",
                  //     prop: "total",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  // ],
                },
                {
                  label: "小计金额",
                  prop: "total_money",
                  align: "center",
                  // children: [
                  //   {
                  //     label: "金额",
                  //     prop: "total_money",
                  //     width: 100,
                  //     align: "center",
                  //   },
                  //   {
                  //     label: "算法",
                  //     prop: "algorithm",
                  //     width: 200,
                  //     align: "center",
                  //   },
                  // ],
                },
                {
                  label: "商品毛利",
                  prop: "def_money",
                  width: 100,
                },
              ],
            },
            {
              title: "销售金额",
              type: "object",
              value: [
                {
                  label: "商品金额",
                  value: this.$money(res.order_info.item_money),
                },
                {
                  label: "运费收入",
                  value: this.$money(res.order_info.trans_money),
                },
                {
                  label: "订单总金额",
                  value: this.$money(res.order_info.total_money),
                },
                {
                  label: "总数量",
                  value: res.order_info.num,
                },
                {
                  label: "运费支出",
                  value: this.$money(res.order_info.trans_money_self),
                },
                {
                  label: "余额抵扣",
                  value: this.$money(res.order_info.pre_money),
                },
                {
                  label: "净毛利",
                  value: this.$money(Number(res.order_info.real_profit_money)),
                },
                {
                  label: "应收总金额",
                  value: this.$money(
                    Number(res.order_info.total_money) -
                      Number(res.order_info.pre_money)
                  ),
                },
              ],
            },
            {
              title: "收款信息",
              type: "array",
              value: payData,
              column: [
                {
                  label: "收款账户",
                  prop: "account_name",
                },
                {
                  label: "收款",
                  prop: "all_price",
                },
                {
                  label: "结款",
                  prop: "pay_price",
                },
                {
                  label: "余款",
                  prop: "last_price",
                },
                {
                  label: "时间",
                  prop: "create_time",
                },
                {
                  label: "类型",
                  prop: "pay_type",
                },
                {
                  label: "操作",
                  prop: "operation",
                },
              ],
            },
            {
              title: "收款信息",
              type: "object",
              value: [
                {
                  label: "已收金额",
                  value: this.$money(res.order_info.payed_money),
                },
                {
                  label: "未收金额",
                  value: this.$money(res.order_info.last_money),
                },
              ],
            },
            {
              title: "订单备注",
              type: "object",
              value: [
                {
                  label: "公司名称",
                  value: res.order_info.comp_remark,
                },
                {
                  label: "其它备注",
                  value: res.order_info.remark,
                },
              ],
            },
            {
              title: "溯源信息",
              type: "array",
              value: item_way,
              column: [
                {
                  label: "ID",
                  prop: "id",
                  width: 80,
                },
                {
                  label: "溯源码",
                  prop: "code_value",
                },
                // {
                //   label: "品名",
                //   prop: "item_name",
                // },
                // {
                //   label: "会员号",
                //   prop: "customer_id",
                // },
                {
                  label: "操作人",
                  prop: "user_name",
                  width: 100,
                },
                {
                  label: "溯源照片",
                  prop: "pics",
                  width: 200,
                },
                {
                  label: "更新时间",
                  prop: "update_time",
                  width: 100,
                },
              ],
            },
          ];

          this.previewParams.key = new Date().getTime();
          this.previewParams.visible = true;
          this.previewParams.type = "sale";
        } else {
          this.$message.error("获取详情失败");
        }
      });
    },
    closefreightConfig() {
      this.freightConfig.visible = false;
      this.freightConfig.key = new Date().getTime();
      this.getlist();
      this.getlistyu();
    },
    freight(row, type) {
      this.freightConfig.key = new Date().getTime();
      this.freightConfig.visible = true;
      this.freightConfig.data.money = this.$money(row.trans_money);
      this.freightConfig.data.from_sn = row.form_sn;
      this.freightConfig.data.shop_id = row.shop_id;
      this.freightConfig.data.user_id = JSON.parse(getRoles()).user_id;
      this.freightConfig.data.customer_id = row.customer_id;
      this.freightConfig.data.supplier_id = 0;
      this.freightConfig.data.part_id = JSON.parse(getRoles()).part_id;
      this.freightConfig.data.id = "";
      this.freightConfig.data.comp_id = row.comp_id;
      this.freightConfig.data.remark = "";
      this.freightConfig.data.type = type;
    },
    statisticalSummary(obj) {
      let data = {
        shop_id: obj.shop_id,
        customer_id: obj.customer_id,
        form_sn: obj.form_sn,
        supplier_type: obj.supplier_type,
        status: obj.status,
        user_id: obj.user_id,
        comp_id: JSON.parse(getRoles()).comp_id,
        begin_time: obj.begin_time,
        end_time: obj.end_time,
      };
      getOrderAllInfo(data).then((res) => {
        if (res.code == 1) {
          this.summarizeData = res.query_res;
        } else {
          this.$message.error(res.data.msg || "获取失败");
        }
      });
    },
    // 查看事件
    show(row) {
      if (!row.item_way) {
        row.item_way = {
          pics: "",
        };
      }
      this.sourceTracingParams.key = new Date().getTime(); //  row.id; // new
      this.sourceTracingParams.visible = true;
      this.sourceTracingParams.form_sn = row.form_sn;
      this.sourceTracingParams.memberId = row.customer_id;
      this.sourceTracingParams.memberName =
        row.customer_id + "-" + row.customer_name;
      this.sourceTracingParams.item_way_num = row.item_way_num;
      this.sourceTracingParams.flow_type = 1;
      this.sourceTracingParams.item_way_data = row;
    },
    handleSourceTracingClose() {
      this.sourceTracingParams.id = 0;
      this.sourceTracingParams.key = "";
      this.sourceTracingParams.visible = false;
      this.sourceTracingParams.flow_type = 0;
      this.getlist();
      this.getlistyu();
    },

    // sourceTracing(row) {
    //   this.sourceTracingParams.key = new Date().getTime(); //  row.id; // new Date().getTime();
    //   this.sourceTracingParams.visible = true;
    //   this.sourceTracingParams.form_sn = row.form_sn;
    //   this.sourceTracingParams.id = row.id;
    //   this.sourceTracingParams.flow_type = 1;
    // },
    // handleSourceTracingClose() {
    //   this.sourceTracingParams.visible = false;
    //   this.sourceTracingParams.form_sn = "";
    //   this.sourceTracingParams.id = 0;
    //   this.sourceTracingParams.key = "";
    //   this.sourceTracingParams.flow_type = 0;
    // },
    checkout(row) {
      this.$confirm("是否确定撤回该单据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderSellUnDo({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("撤回成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg || "撤回失败");
          }
        });
      });
    },
    print() {
      this.$message.success("开发中...");
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderSellDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRowsyu(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderSellDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlistyu();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow(id) {
      if (id) {
        orderSellGetList({ id: id }).then((res) => {
          if (res.code == 1) {
            this.freight(res.data[0]);
          }
        });
      }
      if (this.dialogParams.status == 10) {
        this.activeId = 2;
        this.dialogParams.status = 0;
      } else {
        this.activeId = 1;
      }

      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
      this.getlistyu();
    },
    closeThePopUpWindow2() {
      this.shoudGetParams.visible = false;
      this.shoudGetParams.key = new Date().getTime();
      this.getlist();
      this.getlistyu();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.form_sn;
    },
    // 编辑合并付款弹窗
    shoudGetButton(row) {
      this.shoudGetParams.key = new Date().getTime();
      this.shoudGetParams.visible = true;
      this.shoudGetParams.form_sn = row.form_sn;
      this.shoudGetParams.type = 1;
      this.shoudGetParams.unpaidAmount = this.$money(row.last_money);
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          if (key == "supplier_types" && this.isTakeoutRole) {
            continue;
          }
          if (Array.isArray(data[key])) {
            if (data[key].length == 0 && key == "create_time") {
              delete this.basicListconfig.searchParameters.begin_time;
              delete this.basicListconfig.searchParameters.end_time;
              if (!this.isTakeoutRole) {
                delete this.basicListconfig.searchParameters["supplier_type"];
              }
            } else {
              if (key == "supplier_types") {
                this.basicListconfig.searchParameters["supplier_type"] =
                  data[key].join(",");
              } else {
                this.basicListconfig.searchParameters.begin_time = data[key][0];
                this.basicListconfig.searchParameters.end_time = data[key][1];
              }
            }
          }
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.enforceTakeoutSupplierType(this.basicListconfig.searchParameters);

        this.getlist();
      }
    },

    exportExcel() {
      let headers = {
        "x-token": getSession(),
      };

      let url = this.downloadUrl;

      this.basicListconfig.searchParameters.with_joinshop = 1;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      let export_params = this.basicListconfig.searchParameters;

      axios({
        method: "GET",
        url: url,
        responseType: "blob", // 重要，设置响应类型为blob
        params: export_params,
        withCredentials: true, // 如果需要携带 cookie
        headers: {
          "x-token": getSession(), // 添加自定义请求头
        },
      })
        .then((response) => {
          // 创建一个新的 Blob 对象，使用响应数据
          const blob = new Blob([response.data]);
          // 为 Blob 生成一个链接
          const downloadUrl = window.URL.createObjectURL(blob);
          // 创建一个临时的 <a> 标签用于下载
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "醉真实-销售单-导出数据.xlsx"); // 设置下载文件名
          document.body.appendChild(link);
          link.click(); // 模拟点击进行下载
          document.body.removeChild(link); // 下载完成后移除元素
          window.URL.revokeObjectURL(downloadUrl); // 释放掉blob对象使用的内存
        })
        .catch((error) => {
          console.error("下载文件失败:", error);
        });
    },
    // 搜索事件
    searchEventyu(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfigyu.page = page;
        if (pageSize) this.basicListconfigyu.searchParameters.limit = pageSize;
        this.getlistyu();
      } else if (data) {
        for (const key in data) {
          if (key == "supplier_types" && this.isTakeoutRole) {
            continue;
          }
          if (Array.isArray(data[key])) {
            if (data[key].length == 0) {
              delete this.basicListconfigyu.searchParameters.begin_time;
              delete this.basicListconfigyu.searchParameters.end_time;
              if (!this.isTakeoutRole) {
                delete this.basicListconfigyu.searchParameters["supplier_type"];
              }
            } else {
              if (key == "supplier_types") {
                this.basicListconfigyu.searchParameters["supplier_type"] =
                  data[key].join(",");
              } else {
                this.basicListconfigyu.searchParameters.begin_time =
                  data[key][0];
                this.basicListconfigyu.searchParameters.end_time = data[key][1];
              }
            }
          }
          this.basicListconfigyu.searchParameters[key] = data[key];
        }
        this.basicListconfigyu.searchParameters.page = 1;
        this.enforceTakeoutSupplierType(this.basicListconfigyu.searchParameters);
        this.getlistyu();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.enforceTakeoutSupplierType(this.basicListconfig.searchParameters);
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfig.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfig.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }
      this.statisticalSummary(this.basicListconfig.searchParameters);
      orderSellGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data.map((item) => {
            if (!item.pics) item.pics = "";
            return item;
          });

          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    getlistyu() {
      this.basicListconfigyu.loading = true;
      this.enforceTakeoutSupplierType(this.basicListconfigyu.searchParameters);
      // 用户选中店铺时，按所选店铺查看; 未选时，按用户权限所有店面查询
      if (!this.basicListconfigyu.searchParameters["shop_id"]) {
        if (this.shopIds.length != 0) {
          this.basicListconfigyu.searchParameters["shop_id"] =
            this.shopIds.join(", ");
        }
      }
      this.basicListconfigyu.searchParameters["status"] = 10;
      this.statisticalSummary(this.basicListconfigyu.searchParameters);
      orderSellGetList(this.basicListconfigyu.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfigyu.loading = false;
          this.basicListconfigyu.data = res.data.map((item) => {
            if (!item.pics) item.pics = "";
            return item;
          });

          this.basicListconfigyu.total = res.count;
        } else {
          this.basicListconfigyu.loading = false;
          this.$message.error(res.data.msg);
        }
      });
    },
    // 获取基础数据，获取完后才能拿列表
    obtainDataSource() {
      userGetlist({ limit: 10000, status: 0 }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "user_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
            return item;
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
      return Promise.all([this.getShops(), this.getCustomers()]);
    },

    // 依据权限，获取门店列表
    getShops() {
      if (this.roleId == 4 || this.isTakeoutRole) {
        return userPermissionShopGetList({
          comp_id: this.compId,
          user_id: this.userId,
          permission_id: this.getPermissionId("销售-销售单-查看"),
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });

        // 高级别所看门店不受控制
      } else {
        return getshoplist({
          limit: 10000,
          status: 0,
          comp_id: this.compId,
        }).then((res) => {
          if (res.code == 1) {
            this.shopIds = res.data.map((item) => item.id);
            this.basicListconfig.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
            this.basicListconfigyu.search.map((item) => {
              if (item.key == "shop_id") {
                item.options = res.data.map((item) => {
                  return {
                    label: item.name,
                    value: Number(item.id),
                  };
                });
              }
            });
          } else {
            this.$message.error(res.data.msg || "获取门店数据源失败！");
          }
        });
      }
    },

    // 获取顾客列表
    getCustomers() {
      return customerGetList({
        limit: 10000,
        status: 0,
        comp_id: JSON.parse(getRoles()).comp_id,
      }).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "customer_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
          });
          this.basicListconfigyu.search.map((item) => {
            if (item.key == "customer_id") {
              item.options = res.data.map((item) => {
                return {
                  label: item.name,
                  value: item.id,
                };
              });
            }
          });
        } else {
          this.$message.error(res.data.msg || "获取供应商数据源失败！");
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/salesManagement/index.vue